// footer
// maybe this should be moved into shared js components
var CollapseComponent = (function CollapseComponent() {
    const cookieYesButton = document.querySelector('.cookieyes-button');
    let triggerElements = document.querySelectorAll('[data-toggle="collapse"]');
	const manageCookiesButton = document.querySelectorAll('[data-manageCookies]');

	function attachEvents() {

		if (manageCookiesButton.length > 0) {
			manageCookiesButton.forEach(element => {
				element.addEventListener('click', () => {
					const initialManageSettings = document.querySelector('#onetrust-pc-btn-handler');
					const secondaryManageSettings = document.querySelector('#ot-sdk-btn-floating [aria-label]');
					if (initialManageSettings) {
						initialManageSettings.click();
					} else if (secondaryManageSettings) {
						secondaryManageSettings.click();
					}
				})
			});
		}
		
        cookieYesButton && cookieYesButton.addEventListener('click', e => {
            revisitCkyConsent();
            e.preventDefault();
        });

        triggerElements.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const triggerElement = e.currentTarget;
                const selector = triggerElement.getAttribute('data-target');
                collapse(selector, triggerElement);
            })
        })
    }

    function collapse(selector, triggerElement) {
        const targets = Array.from(document.querySelectorAll(selector));
        targets.forEach(target => {
            target.classList.toggle('show');
        });
        if (triggerElement.classList.contains("collapsed")) {
            triggerElement.classList.remove("collapsed");
            triggerElement.setAttribute("aria-expanded", true)
        } else {
            triggerElement.classList.add("collapsed");
            triggerElement.setAttribute("aria-expanded", false);
        }
    }

    attachEvents();
}());